export default class HookUtil
{
      static hookAJAX() 
      {
        XMLHttpRequest.prototype.nativeOpen = XMLHttpRequest.prototype.open;
        var customizeOpen = function (method, url, async, user, password) {
          // do something
          if(url)
          {
              if(url.indexOf("?") != -1)
              {
                url+=("&token="+localStorage.getItem("userToken"));
              }
              else
              {
                url+=("?token="+localStorage.getItem("userToken"));
              }
          }
          this.nativeOpen(method, url, async, user, password);
          //this.setRequestHeader("token",localStorage.getItem("userToken"));
        };
    
        XMLHttpRequest.prototype.open = customizeOpen;
      }
    
      /**
       *全局拦截Image的图片请求添加token
       *
       */
      static hookImg() 
      {
        const property = Object.getOwnPropertyDescriptor(Image.prototype, 'src');
        const nativeSet = property.set;
    
        function customiseSrcSet(url) 
        {
          if(url)
          {
              if(url.indexOf("?") != -1)
              {
                url+=("&token="+localStorage.getItem("userToken"));
              }
              else
              {
                url+=("?token="+localStorage.getItem("userToken"));
              }
          }
          
          nativeSet.call(this, url);
        }
        Object.defineProperty(Image.prototype, 'src', {
          set: customiseSrcSet,
        });
      }
    
      /**
       * 拦截全局open的url添加token
       *
       */
      static hookOpen() {
        const nativeOpen = window.open;
        window.open = function (url,_name='') {
          // do something
          if(url)
          {
              if(url.indexOf("?") != -1)
              {
                url+=("&token="+localStorage.getItem("userToken"));
              }
              else
              {
                url+=("?token="+localStorage.getItem("userToken"));
              }
          }
          nativeOpen.call(this, url,_name);
        };
      }
    
      static hookFetch() {
        var fet = Object.getOwnPropertyDescriptor(window, 'fetch')
        Object.defineProperty(window, 'fetch', {
          value: function (a, b, c) {
            // do something
            return fet.value.apply(this, args)
          }
        })
      }
}



// WEBPACK FOOTER //
// ./src/utils/HookUtil.js